import { useContext, useCallback } from "react";
import * as Sentry from "@sentry/react";
import { observer } from "mobx-react-lite";
import { withRouter } from "react-router";
import { RootStoreContext } from "src/stores/RootStore";
import { useTranslation } from "react-i18next";
import { UI } from "@wwimmo/ui";
import { USER_SETTING } from "src/stores/UserSettingsStore";
import styles from "./NotificationSettings.module.css";

const NotificationSettingsBase = () => {
    const { userSettingsStore } = useContext(RootStoreContext);

    const { t } = useTranslation();

    const toggleUserSetting = useCallback(
        (key: USER_SETTING) => (checked: boolean) => {
            userSettingsStore.setUserSetting({
                key: key,
                value: checked.toString()
            });
        },
        [userSettingsStore]
    );

    return (
        <UI.Container className="pt-4">
            <UI.Row>
                <UI.Col xs={{ span: 8, offset: 2 }} lg={{ span: 6, offset: 3 }}>
                    <UI.Card
                        className={styles.NotificationSettingsContainer}
                        title={t("screens.kredi_flow.title").toString()}
                    >
                        <div className={styles.CredVisaNotificationContainer}>
                            <UI.Switch
                                label={t("screens.notification_settings.visa_notifications").toString()}
                                labelPosition="after"
                                checked={
                                    userSettingsStore.userSetting[USER_SETTING.CRED_VISA_NOTIFICATION] === "true"
                                        ? true
                                        : false
                                }
                                onToggle={toggleUserSetting(USER_SETTING.CRED_VISA_NOTIFICATION)}
                            />
                        </div>
                    </UI.Card>
                </UI.Col>
            </UI.Row>
        </UI.Container>
    );
};

export const NotificationSettings = withRouter(Sentry.withProfiler(observer(NotificationSettingsBase)));
